import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_BOOKINGMATRIXREPORTS,
  GET_BOOKINGREPORTS,
  GET_CUSTOMERSREPORTS,
  GET_CUSTOMERMATRIXREPORTS,
  GET_REVENUEREPORTS,
  GET_REVENUEMATRIXREPORTS,
  GET_REVENUEREPORTDOWNLOAD,
  GET_MISREPORTS,
  GET_MISREPORTSDOWNLOAD
} from "resources/actionTypes";
import { getBookingMatrixReports, getBookingReportsList, getCustomerList,getCustomerReport,getRevenueReport,getRevenueMatrix, getMisReportApi,getMisReportDownloadApi } from "services/ReportsService";

function* fetchBookingReports(action) {
  const payload = action.payload || {};
  const bookingList = yield call(getBookingReportsList, payload);
  if (bookingList.success) {
    yield put({
      type: GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_SUCCESS,
      bookingList: bookingList,
    });
  } else {
    yield put({
      type: GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_FAILED,
      message: bookingList.message,
    });
    toast.error(bookingList?.message || "fetch Booking Reports Failed");
  }
}

export function* fetchBookingReportsWatcher() {
  yield takeEvery(
    GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_REQUESTED,
    fetchBookingReports
  );
}

function* fetchBookingMatrixReports(action) {
  const payload = action.payload || {};
  
  const bookingMatrixReports = yield call(getBookingMatrixReports, payload);
  if (bookingMatrixReports.success) {
    yield put({
      type: GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_SUCCESS,
      bookingMatrixReports: bookingMatrixReports,
    });
  } else {
    yield put({
      type: GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_FAILED,
      message: bookingMatrixReports.message,
    });
    toast.error(bookingMatrixReports?.message || "Get Booking Matrix Failed");
  }
}

export function* fetchBookingMatrixReportsWatcher() {
  yield takeEvery(
    GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_REQUESTED,
    fetchBookingMatrixReports
  );
}

function* fetchCustomerList(action) {
  const payload = action.payload || {};
  
  const customerList = yield call(getCustomerList, payload);
  if (customerList.success) {
    yield put({
      type: GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_SUCCESS,
      customerList: customerList,
    });
  } else {
    yield put({
      type: GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_FAILED,
      message: customerList.message,
    });
    toast.error(customerList?.message || "Get Customer Failed");
  }
}

export function* fetchCustomerListWatcher() {
  yield takeEvery(
    GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_REQUESTED,
    fetchCustomerList
  );
}

function* fetchCustomerMatrix(action) {
  const payload = action.payload || {};
  
  const customerMatrix = yield call(getCustomerReport, payload);
  if (customerMatrix.success) {
    yield put({
      type: GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_SUCCESS,
      customerMatrix: customerMatrix,
    });
  } else {
    yield put({
      type: GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_FAILED,
      message: customerMatrix.message,
    });
    toast.error(customerMatrix?.message || "Get Customer Matrix Failed");
  }
}

export function* fetchCustomerMatrixWatcher() {
  yield takeEvery(
    GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_REQUESTED,
    fetchCustomerMatrix
  );
}

function* fetchRevenueList(action) {
  const payload = action.payload || {};

  const revenueList = yield call(getRevenueReport, payload);
  if (revenueList.success) {
    yield put({
      type: GET_REVENUEREPORTS.GET_REVENUEREPORTS_SUCCESS,
      revenueList: revenueList,
    });
  } else {
    yield put({
      type: GET_REVENUEREPORTS.GET_REVENUEREPORTS_FAILED,
      message: revenueList.message,
    });
    toast.error(revenueList?.message || "Get RevenueList Failed");
  }
}

export function* fetchRevenueListWatcher() {
  yield takeEvery(
    GET_REVENUEREPORTS.GET_REVENUEREPORTS_REQUESTED,
    fetchRevenueList
  );
}

function* fetchRevenueMatrix(action) {
  const payload = action.payload || {};
  
  const revenueMatrix = yield call(getRevenueMatrix, payload);
  if (revenueMatrix.success) {
    yield put({
      type: GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_SUCCESS,
      revenueMatrix: revenueMatrix,
    });
  } else {
    yield put({
      type: GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_FAILED,
      message: revenueMatrix.message,
    });
    toast.error(revenueMatrix?.message || "Get RevenueMatrix Failed");
  }
}

export function* fetchRevenueMatrixWatcher() {
  yield takeEvery(
    GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_REQUESTED,
    fetchRevenueMatrix
  );
}

function* getDocumentExport(action) {
  const payload = action.payload || {};
  const bokingListExport = yield call(getRevenueReport, payload);
  if (bokingListExport.success) {
    yield put({
      type: GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_SUCCESS,
    });
    if(payload?.export){
      toast.success(bokingListExport.message);
    }
  } else {
    yield put({
      type: GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_FAILED,
      message: bokingListExport.message,
    });
    toast.error(bokingListExport?.message || 'Downloading Report Failed');
  }
}

export function* getDocumentExportWatcher() {
  yield takeEvery(
    GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_REQUESTED,
    getDocumentExport
  );
}

function* fetchMisList(action) {
  const payload = action.payload || {};

  const misList = yield call(getMisReportApi, payload);
  if (misList.success) {
    yield put({
      type: GET_MISREPORTS.GET_MISREPORTS_SUCCESS,
      misList: misList,
    });
  } else {
    yield put({
      type: GET_MISREPORTS.GET_MISREPORTS_FAILED,
      message: misList.message,
    });
    toast.error(misList?.message || "Get MisList Failed");
  }
}

export function* fetchMisListWatcher() {
  yield takeEvery(
    GET_MISREPORTS.GET_MISREPORTS_REQUESTED,
    fetchMisList
  );
}

function* getMisReportDownload(action) {
  const payload = action.payload || {};
  const misListExport = yield call(getMisReportDownloadApi, payload);
  if (misListExport.success) {
    yield put({
      type: GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_SUCCESS,
    });
    if(payload?.export){
      toast.success(misListExport.message);
    }
  } else {
    yield put({
      type: GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_FAILED,
      message: misListExport.message,
    });
    toast.error(misListExport?.message || 'Downloading Report Failed');
  }
}

export function* getMisReportExportWatcher() {
  yield takeEvery(
    GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_REQUESTED,
    getMisReportDownload
  );
}